module.exports = __webpack_public_path__ + "static/img/icon_statistics.6cbd17c5.svg";